import type { SVGProps } from "react";

export function CheeseIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 8.99981V12.4998C20.4696 12.4998 19.9609 12.7105 19.5858 13.0856C19.2107 13.4607 19 13.9694 19 14.4998C19 15.0302 19.2107 15.539 19.5858 15.914C19.9609 16.2891 20.4696 16.4998 21 16.4998V19.9998L4.519 20.0078C3.56 18.3718 3 16.4038 3 14.2868C3 11.6538 3.865 9.25281 5.288 7.43281C6.857 5.42781 9.103 4.12781 11.615 4.00781L21 8.99981ZM21 8.99981H4.278M15 12.9998V13.0098M8 12.9998V13.0098M11 15.9998V16.0098"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
